import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from '../services/baseApi.js';
import { loggerMiddleware } from '../store/middleware/logger.js';
import layersReducer from '../store/slices/layersSlice.js';
import mapReducer from '../store/slices/mapSlice.js';
import measureReducer from '../store/slices/measureSlice.js';
import uiReducer from '../store/slices/uiSlice.js';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    layers: layersReducer,
    map: mapReducer,
    measure: measureReducer,
    ui: uiReducer,
  },
  middleware: (getDefault) =>
    getDefault({
      // Map extents and coordinates are plain data, so the default checks are
      // worth keeping; they catch accidental leakage of SDK objects into state,
      // which is exactly the mistake the map/state boundary exists to prevent.
      serializableCheck: true,
      immutableCheck: true,
    })
      .concat(baseApi.middleware)
      .concat(loggerMiddleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
